import React, { FC, useState } from 'react';
import { Box, Container, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { ArrowWhiteIcon } from '../../svgs/expertise';

interface DataCentersCapabilitiesProps {
  image: string;
  title: string;
  description: string;
  subtitle: string;
  list: Array<{ text: string }>;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    container: {
      backgroundImage: ({ image }: Partial<DataCentersCapabilitiesProps>) => `url(${image})`,
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      height: 785,
      padding: theme.spacing(2, 0),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(18, 0),
        height: 750,
      },
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(18, 0),
      },
      [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(5, 0),
      },
      [theme.breakpoints.up('xl')]: {
        padding: theme.spacing(15, 0),
      },
    },
    title: {
      fontSize: 32,
      color: theme.palette.primary.main,
      fontWeight: 800,
      [theme.breakpoints.up('sm')]: {
        fontSize: 40,
      },
      [theme.breakpoints.up('md')]: {
        fontSize: 45,
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: 80,
      },
    },
    text: {
      fontSize: 16,
      color: '#F7F7F7',
      fontWeight: 500,
      [theme.breakpoints.up('md')]: {
        fontSize: 18,
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: 24,
      },
    },
    subtitle: {
      fontSize: 25,
      color: '#F7F7F7',
      fontWeight: 700,
      textDecoration: 'underline',
      marginBottom: theme.spacing(4),
      cursor: 'pointer',
      [theme.breakpoints.up('lg')]: {
        fontSize: 35,
      },
    },
    listItem: {
      color: '#F7F7F7',
      marginLeft: -10,
    },
    icon: {
      transition: 'transform 0.3s',
      marginLeft: 10,
      marginTop: -25,
      cursor: 'pointer',
    },
  });
});

const DataCentersCapabilitiesSection: FC<DataCentersCapabilitiesProps> = ({ image, title, description, subtitle, list }) => {
  const classes = useStyles({ image });
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <Box className={classes.container} data-aos="fade-up" data-aos-delay="400">
      <Container fixed>
        <Typography className={classes.title}>{title}</Typography>
        <Typography className={classes.text}>{description}</Typography>
        <Box mb={6} />
        <Box display="flex" alignItems="center" onClick={handleToggle}>
          <Typography className={classes.subtitle}>{subtitle}</Typography>
          <ArrowWhiteIcon
            className={classes.icon}
            style={{
              transform: isOpen ? 'rotate(0deg)' : 'rotate(180deg)',
            }}
          />
        </Box>
        {isOpen && (
          <ul>
            {list.map((item, index) => (
              <li className={classes.listItem} key={index}>
                <Typography className={classes.text}>{item.text}</Typography>
              </li>
            ))}
          </ul>
        )}
      </Container>
    </Box>
  );
};

export default DataCentersCapabilitiesSection;
